import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BreadCrumbsComponent } from '../bread-crumbs/bread-crumbs.component';
import { Breadcrumb } from '../../_models/breadcrumb.model';

@Component({
    selector: 'app-page-header',
        standalone: true,
templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    imports: [BreadCrumbsComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderComponent {
  @Input() title: string | undefined;
  @Input() imgPath: string | undefined;
  @Input() breadcrumbs:Breadcrumb[] | undefined;

}
